/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-09-15 11:15:36
 * @LastEditors: yd
 * @LastEditTime: 2020-09-15 11:18:30
 */

// 邮箱设置
import http from '../httpConfig'
const table = 'mrbase_sys_email_smtp'
//  系统邮箱详情接口
export const emailSetList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systememail/find-email/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//  修改系统邮箱设置
export const emailSetUpadate = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systememail/update-email/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
